<script setup lang="ts">
import TagBox from './TagBox.vue'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useTagBox } from '@/composables/tags/useTagBox'
import type { Elemental } from '~~/src/types/elemental'
const props = defineProps<{
  elemental: Elemental
}>()

defineOptions({
  name: 'TagMenu',
})

const { open, toggleOpen, isLoading } = useTagBox(props.elemental)
</script>

<template>
  <DropdownMenu :open="open" @update:open="toggleOpen">
    <DropdownMenuTrigger :disabled="isLoading">
      <Button
        :disabled="isLoading"
        variant="snack-icon"
        size="icon"
        type="button"
      >
        <div i-material-symbols:shoppingmode-outline class="w-6 h-6" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      <TagBox :open="open" :elemental="elemental" />
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<style lang="scss">
.tag-menu {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 12px;

  .tag-menu-item {
    min-width: 45px;

    input {
      width: min-content;
      border: none;
      outline: none;
      background: transparent;
      padding: 0 0.5rem;
    }
  }
}
</style>
